export * from './alertConfigures.service';
import { AlertConfiguresService } from './alertConfigures.service';
export * from './alerts.service';
import { AlertsService } from './alerts.service';
export * from './assetLocationHistories.service';
import { AssetLocationHistoriesService } from './assetLocationHistories.service';
export * from './assetLocations.service';
import { AssetLocationsService } from './assetLocations.service';
export * from './assets.service';
import { AssetsService } from './assets.service';
export * from './auditLogs.service';
import { AuditLogsService } from './auditLogs.service';
export * from './deviceHistories.service';
import { DeviceHistoriesService } from './deviceHistories.service';
export * from './emails.service';
import { EmailsService } from './emails.service';
export * from './floors.service';
import { FloorsService } from './floors.service';
export * from './orgProfiles.service';
import { OrgProfilesService } from './orgProfiles.service';
export * from './routers.service';
import { RoutersService } from './routers.service';
export * from './tags.service';
import { TagsService } from './tags.service';
export * from './userProfiles.service';
import { UserProfilesService } from './userProfiles.service';
export * from './users.service';
import { UsersService } from './users.service';
export const APIS = [AlertConfiguresService, AlertsService, AssetLocationHistoriesService, AssetLocationsService, AssetsService, AuditLogsService, DeviceHistoriesService, EmailsService, FloorsService, OrgProfilesService, RoutersService, TagsService, UserProfilesService, UsersService];
